module.exports = __webpack_public_path__ + "img/161.48f5f80c.png";